"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _reactTransitionGroup = require("react-transition-group");

var _once = require("../_shared/once");

var _options = _interopRequireDefault(require("./options"));

var _informContent = _interopRequireDefault(require("./inform-content"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var warnAppearanceSecondary = (0, _once.once)(function () {
  /*eslint-disable no-console, max-len */
  console.warn('Warning:', '<Dropdown appearance="secondary" />  is deprecated. See https://uikit.xsolla.com/components/dropdown');
  /*eslint-enable */
});
var warnSizeSm = (0, _once.once)(function () {
  /*eslint-disable no-console, max-len */
  console.warn('Warning:', '<Dropdown size="sm" />  is deprecated. See https://uikit.xsolla.com/components/dropdown');
  /*eslint-enable */
});

var Dropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "instance", /*#__PURE__*/_react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false
    });

    _defineProperty(_assertThisInitialized(_this), "showDropdown", function () {
      return _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideDropdown", function () {
      return _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVisible", function () {
      return _this.setState({
        visible: !_this.state.visible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      return _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;
      e.preventDefault();

      if (!disabled) {
        _this.toggleVisible();
      }

      onClick && onClick();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (value) {
      _this.props.autohide && _this.toggleVisible();
      _this.props.onChange && _this.props.onChange(value);
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          autosize = _this$props2.autosize,
          options = _this$props2.options,
          optionsWidth = _this$props2.optionsWidth,
          type = _this$props2.type,
          trigger = _this$props2.trigger,
          onScrollOptions = _this$props2.onScrollOptions,
          fetching = _this$props2.fetching,
          rootDataId = _this$props2.rootDataId,
          rest = _objectWithoutProperties(_this$props2, ["children", "autosize", "options", "optionsWidth", "type", "trigger", "onScrollOptions", "fetching", "rootDataId"]);

      if (rest.appearance === 'secondary') {
        warnAppearanceSecondary();
      }

      if (rest.size === 'sm') {
        warnSizeSm();
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('xsui-dropdown', autosize && 'xsui-dropdown--autosize'),
        onMouseEnter: trigger === 'hover' ? this.showDropdown : undefined,
        onMouseLeave: trigger === 'hover' ? this.hideDropdown : undefined,
        ref: this.instance,
        "data-id": rootDataId
      }, /*#__PURE__*/_react["default"].cloneElement(children, {
        focused: typeof children.type === 'function' ? this.state.visible : null,
        onClick: this.handleOnClick
      }), options.length > 0 && type === 'options' && /*#__PURE__*/_jsx(_reactTransitionGroup.TransitionGroup, {}, void 0, this.state.visible && /*#__PURE__*/_jsx(_reactTransitionGroup.CSSTransition, {
        classNames: "slide-transition",
        timeout: 100
      }, void 0, /*#__PURE__*/_react["default"].createElement(_options["default"], _extends({}, rest, {
        items: options,
        fetching: fetching,
        onChange: this.handleOnChange,
        onScroll: onScrollOptions,
        size: optionsWidth || rest.size,
        buttonRef: trigger === 'hover' ? this.instance : undefined
      })))), type === 'inform' && /*#__PURE__*/_jsx(_reactTransitionGroup.TransitionGroup, {}, void 0, this.state.visible && /*#__PURE__*/_jsx(_reactTransitionGroup.CSSTransition, {
        classNames: "slide-transition",
        timeout: 100
      }, void 0, /*#__PURE__*/_react["default"].createElement(_informContent["default"], _extends({}, rest, {
        onChange: this.handleOnChange,
        size: optionsWidth || rest.size,
        buttonRef: trigger === 'hover' ? this.instance : undefined
      })))));
    }
  }]);

  return Dropdown;
}(_react.PureComponent);

_defineProperty(Dropdown, "defaultProps", {
  options: [],
  optionsWidth: undefined,
  autosize: false,
  type: 'options',
  autohide: true,
  value: null,
  onChange: function onChange() {
    return void 0;
  },
  onScrollOptions: function onScrollOptions() {
    return void 0;
  },
  trigger: 'click',
  className: '',
  disabled: false,
  fetching: false
});

var _default = (0, _reactOnclickoutside["default"])(Dropdown);

exports["default"] = _default;